import { api } from "./api";

export async function requestPasswordReset(email: string): Promise<void> {
  await api.post(
    "auth/password-reset/",
    { email },
    { skipGlobalErrorToast: true },
  );
}

export async function confirmPasswordReset(payload: {
  uid: string;
  token: string;
  new_password: string;
}): Promise<void> {
  await api.post("auth/password-reset/confirm/", payload, {
    skipGlobalErrorToast: true,
  });
}
